import Immutable from 'immutable';

const LOAD = 'assetReview/LOAD';
const LOAD_SUCCESS = 'assetReview/LOAD_SUCCESS';
const LOAD_FAIL = 'assetReview/LOAD_FAIL';

const PDF_LOAD_SUCCESS = 'assetReview/PDF_LOAD_SUCCESS';
const PDF_LOAD_FAIL = 'assetReview/PDF_LOAD_FAIL';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  assetReview: null,
  loading: false,
  assetsPdf: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
    return state
    .set('isLoad', true)
    .set('loadErr', null);

    case LOAD_FAIL:
    return state
    .set('isLoad', false)
    .set('loadErr', action.error)
    .set('assetReview', null);

    case LOAD_SUCCESS:
    return state
    .set('isLoad', false)
    .set('assetReview', action.assetReview);

    case PDF_LOAD_FAIL:
    return state
    .set('isLoad', false)
    .set('loadErr', action.error)
    .set('assetsPdf', null);

    case PDF_LOAD_SUCCESS:
    return state
    .set('isLoad', false)
    .set('assetsPdf', action.assetsPdf);


    default:
    return state;
  }
}

export const getAssetsFarm = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/Assets/');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, assetReview: res });
    return res ;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getFarmAssetsById = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/Assets/Farm/'+id);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, assetReview: { data: res } });

    return res ;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const printAssetData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD});
  try {
    const res = await api.put('/Assets/printpdf', {data});
    if (res.message) {
      dispatch({ type: PDF_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: PDF_LOAD_SUCCESS, assetReview: { data: res } });
    return res ;
  } catch (error) {
    dispatch({ type: PDF_LOAD_FAIL, errorMessage: error });
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/assetReview.js